import React from 'react';
import { Layout } from 'antd';
import './MainLayout.css';

const { Content } = Layout;

interface MainLayoutProps {
  sider: React.ReactNode;
  header: React.ReactNode;
  children: React.ReactNode;
  contentClassName?: string;
  contentStyle?: React.CSSProperties;
}

const MainLayout: React.FC<MainLayoutProps> = ({ sider, header, children, contentClassName, contentStyle }) => {
  return (
    <Layout className="dashboard-layout">
      {sider}
      <Layout>
        {header}
        <Content className={contentClassName} style={contentStyle}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;